'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:ReportSearchController
 * @description
 * # ReportSearchController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ReportsPageController', ['$scope', '$rootScope', '$routeParams', 'ReportService', 'ComplexCriteria', 'Report', 'FlashService', 'ConfirmationService', 'Constants', 'Utils',
    function ($scope, $rootScope, $routeParams, ReportService, ComplexCriteria, Report, FlashService, ConfirmationService, Constants, Utils) {

            $scope.runReport = function () {

                if (!$scope.selectedReportModel.info) {
                    $scope.addBtnDisabled = false;
                }

                $scope.selectedReportModel.SearchCriteria.errorMessage =  null;

                var params = $scope.selectedReportModel.SearchCriteria.getSearchParams($scope.selectedReportModel.selectedReport);

                $scope.selectedReportModel.load(params, function (errorMessage) {
                    if (errorMessage) {
                        $scope.selectedReportModel.SearchCriteria.errorMessage = errorMessage;
                        return;
                    }
                    $scope.changeViewModeTo($scope.reportViewModes.REPORTS);
                });
            };

            $scope.newReport = function () {

                var newReport = new Report($scope);

                $scope.selectedReportModel = newReport;
                $scope.selectedReportModel.SearchCriteria = new ComplexCriteria();
                $scope.isReportTabSelected(newReport);

                $scope.reports.push(newReport);

                $scope.changeViewModeTo($scope.reportViewModes.SEARCH);

                $scope.addBtnDisabled = true;

                $scope.clearSelectedReportFiltersSet();
             };

            $scope.selectReport = function (report) {
                $scope.selectedReportModel.selectedReport = report;
                $scope.selectedReportModel.generateSequence();
                $scope.clearSelectedReportFiltersSet();
                $scope.loadStoredFiltersSetsByReport(report);

                var searchCriteria = new ComplexCriteria();

                $scope.searchCriteriaIsLoading = true;

                searchCriteria.loadFieldTypes(report.id).then(function () {

                    if ($scope.selectedReportModel.SearchCriteria.getConditions().length > 0) {

                        var commonСonditions = [];
                        $scope.selectedReportModel.SearchCriteria.getConditions().forEach(function (condition) {
                            if (condition.selectedFieldType.fieldName && searchCriteria.fieldTypes.some(function (field) { return field.fieldName === condition.selectedFieldType.fieldName; })) {
                                commonСonditions.push(condition);
                            }
                        });

                        if (commonСonditions.length > 0) {
                            searchCriteria.setConditions(commonСonditions);
                        }

                        $scope.searchCriteriaIsLoading = false;
                    }

                    $scope.selectedReportModel.SearchCriteria = searchCriteria;
                });
            };

            $scope.selectReportModel = function (report) {
                $scope.selectedReportModel = report;
            };

            $scope.loadStoredFiltersSetsByReport = function (report) {
              	return ReportService.GetStoredReportFilterSets(report.id).then(function (response) {
                	$scope.selectedReportModel.storedReportFilterSets = response.data.storedReportFilterSets;
             	});
            };

            $scope.saveReportFiltersSet = function () {
              var data = {};

              if ($scope.selectedReportModel.selectedStoredFiltersSet) {
                data = $scope.selectedReportModel.selectedStoredFiltersSet;
                data.storedReportFilterSetJson =  $scope.selectedReportModel.SearchCriteria.getConditionsJSON();
                } else {
                data.reportId = $scope.selectedReportModel.selectedReport.id;
                data.storedReportFilterSetJson = $scope.selectedReportModel.SearchCriteria.getConditionsJSON();
              }

              data.saveCallBack = function (newFiltersSet) {
                if (newFiltersSet.action === Constants.DBActions.Insert) {
                  $scope.selectedReportModel.storedReportFilterSets.push(newFiltersSet);
                  $scope.selectedReportModel.selectedStoredFiltersSet = newFiltersSet;
                } else if (newFiltersSet.action === Constants.DBActions.Update) {
                  $scope.loadStoredFiltersSetsByReport($scope.selectedReportModel.selectedReport);
                }
              }

             Utils.OpenModal('', 'ng1/src/reports/templates/dialogs/saveReportFiltersSetDialog.html', 'saveReportFiltersSetController', data, 'save-report-filters-set-dialog', null, false);
            };

            $scope.clearSelectedReportFiltersSet = function () {
              $scope.selectedReportModel.selectedStoredFiltersSet = null;
              $scope.selectedReportModel.SearchCriteria.clearConditions();
            };

            $scope.deleteSelectedReportFiltersSet = function () {
              var filterSetName = $scope.selectedReportModel.selectedStoredFiltersSet.storedReportFilterSetName;
              ConfirmationService.YesNoConfirmation("Are you sure you want to delete <b>\"{0}\" </b> stored report filters set?".format(filterSetName), null, { title: 'Delete Stored Report Filters Set', yes: 'Yes', no: 'No' })
                .Yes(function ()
                {
                  var loading = FlashService.Loading();
                  $scope.selectedReportModel.selectedStoredFiltersSet.action = Constants.DBActions.Delete;
                  ReportService.ReportFilterSetAction($scope.selectedReportModel.selectedStoredFiltersSet).then(function (response) {
                    if (response.success) {
                      $scope.selectedReportModel.storedReportFilterSets.remove($scope.selectedReportModel.selectedStoredFiltersSet);
                      $scope.selectedReportModel.selectedStoredFiltersSet = null;
                      FlashService.Success("<b>\"{0}\" </b> stored report filters set has been deleted.".format(filterSetName));
                      $scope.selectedReportModel.SearchCriteria.clearConditions();
                    }
                    loading.dismiss();
                  });
                })
                .Ask();
             };

          	$scope.selectStoredFiltersSet = function (storedFiltersSet) {
              $scope.selectedReportModel.selectedStoredFiltersSet = storedFiltersSet;

              $scope.selectedReportModel.SearchCriteria.setConditionsFromJson(storedFiltersSet.storedReportFilterSetJson);
            };

            $scope.closeReport = function (report) {
                if (!$scope.selectedReportModel.info) {
                    $scope.addBtnDisabled = false;
                }

                $scope.reports = $scope.reports.filter(function (item) {
                    return item !== report;
                });

                $scope.reports.forEach(function (report) {
                    report.generateSequence();
                });

                $scope.selectedReportModel = $scope.reports[$scope.reports.length - 1];
            };

            $scope.isRunReportAllowed = function () {
                return $scope.selectedReportModel.selectedReport &&
                    $scope.selectedReportModel.SearchCriteria.getConditions().length > 0 &&
                    $scope.selectedReportModel.SearchCriteria.getWarningMessage() === '';
            };

            $scope.isSearchMode = function () {
                return $scope.selectedReportModel.viewMode === $scope.reportViewModes.SEARCH;
            };

            $scope.isReportsMode = function () {
                return $scope.selectedReportModel.viewMode === $scope.reportViewModes.REPORTS;
            };

            $scope.changeViewModeTo = function (mode) {
                $scope.selectedReportModel.viewMode = mode;
            };

            $scope.isReportTabSelected = function (report) {
                return $scope.selectedReportModel === report;
            };

            $scope.getReportTabName = function (report) {

                if (!report.selectedReport) {
                    return 'New Tab';
                }

                return '{0} #{1}'.format(report.selectedReport.name, report.sequenceId);
            };

            function initSearchControl() {

                $scope.isSearchLoading = true;
                FlashService.ShowProgressBar();

                ReportService.GetReportInfo($rootScope.globals.application.id, $scope.applicationOptionId).then(function (result) {

                    $scope.isSearchLoading = false;
                    FlashService.HideProgressBar();

                    if (result.success) {
                        $scope.searchInfo = result.data;
                    }
                });
            }

            function initialize() {

                $scope.applicationOptionId = $routeParams.id;

                $scope.reportViewModes = {
                    SEARCH: 'SEARCH',
                    REPORTS: 'REPORTS'
                };

                $scope.reports = [];

                initSearchControl();

                $scope.newReport();
            }

            $rootScope.$on('resizeGridEvent', function () {

                if ($scope.selectedReportModel && $scope.selectedReportModel.Grid) {
                    $scope.selectedReportModel.Grid.handleWindowResize();
                }
            });

            initialize();
        }]);
